'use strict';

function parse(reader) {
    reader.readFloatLE('data.params.electric_current');
    reader.readFloatLE('data.params.mapped_value');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/ai-value-parser.js